import { Routes, Route } from 'react-router-dom';
import Chatroom from 'pages/toyotaPremiumOfficialAccount/Chatroom/Chatroom';
import BranchList from 'pages/toyotaPremiumOfficialAccount/BranchList/BranchList';
import ConversationList from 'pages/toyotaPremiumOfficialAccount/ConversationList/ConversationList';
import MemberServices from 'pages/toyotaPremiumOfficialAccount/MemberServices/MemberServices';
import ToyotaPremiumCarSecretary from 'pages/toyotaPremiumOfficialAccount/MemberServices/ToyotaPremiumCarSecretary';
import CustomWallpaper from 'pages/toyotaPremiumOfficialAccount/CustomWallpaper/CustomWallpaper';
import ToyotaPremiumHotaiGo from 'pages/toyotaPremiumOfficialAccount/OwnerReward/ToyotaPremiumHotaiGo';
import CarServiceBooking from '../../pages/toyotaOfficialAccount/CarServiceBooking';
import Layout from 'pages/toyotaPremiumOfficialAccount/layout';
import 'pages/toyotaPremiumOfficialAccount/toyota-premium-namespace.scss';
import ConsultEntry from 'pages/toyotaPremiumOfficialAccount/ConsultEntry/ConsultEntry';

const ToyotaPremiumRouter = () => {
  return (
    <div className="toyota-premium-webview">
      <Routes>
        <Route element={<Layout />}>
          <Route path="/consultation">
            <Route index element={<ConsultEntry />} />
            <Route path="branch-list" element={<BranchList />} />
            <Route path="conversation-list" element={<ConversationList />} />
            <Route
              path="user-chatroom/:conversationId"
              element={<Chatroom role="user" />}
            />
            <Route
              path="sales-rep-chatroom/:conversationId"
              element={<Chatroom role="sales" />}
            />
          </Route>
          <Route path="/member-services" element={<MemberServices />} />
          <Route path="/custom-wallpaper" element={<CustomWallpaper />} />
          <Route path="/hotaisso" element={<ToyotaPremiumHotaiGo />} />
          <Route path="/car-service-booking" element={<CarServiceBooking />} />
          <Route
            path="/car-secretary"
            element={<ToyotaPremiumCarSecretary />}
          />
        </Route>
      </Routes>
    </div>
  );
};

export default ToyotaPremiumRouter;
